import { render, staticRenderFns } from "./SendingPolicies.vue?vue&type=template&id=bcfee554&scoped=true"
import script from "./SendingPolicies.vue?vue&type=script&lang=js"
export * from "./SendingPolicies.vue?vue&type=script&lang=js"
import style0 from "./SendingPolicies.vue?vue&type=style&index=0&id=bcfee554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfee554",
  null
  
)

export default component.exports